<template>
  <div class="store-grid" id="store-grid">
    <div 
      v-for="cat in categories.slice(1)" 
      :key="cat"
      class="category-group fade-up" 
      :class="{ hidden: currentCategory !== '全部' && currentCategory !== cat }"
      :data-category="cat"
    >
      <!-- 头部信息 -->
      <div class="category-header">
        <span class="category-name">{{ getCategoryLabel(cat) }}</span>
        <div class="category-line"></div>
        <span class="category-count">{{ getProductsByCategory(cat).length }} 件</span>
      </div>
      <!-- 产品网格 -->
      <div class="products-grid">
        <div 
          v-for="p in getProductsByCategory(cat)" 
          :key="p.id"
          class="product-card fade-up"
          :data-category="p.category"
          :data-id="p.id"
        >
          <ProductCard :img-url-prefix="imgUrlPrefix" :product="p" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductCard from './ProductCard.vue'

export default {
  name: 'ProductGrid',
  components: {
    ProductCard
  },
  props: {
    imgUrlPrefix: {
      type: String,
      required: true
    },
    products: {
      type: Array,
      required: true
    },
    categories: {
      type: Array,
      required: true
    },
    categoryLabels: {
      type: Object,
      required: true
    },
    currentCategory: {
      type: String,
      required: true
    }
  },
  mounted() {
  },
  methods: {
    getCategoryLabel(cat) {
      return this.categoryLabels[cat] || cat;
    },
    getProductsByCategory(cat) {
      return this.products.filter(p => p.category === cat);
    },
  }
}
</script>

<style lang="less" scoped>
.store-grid {
  padding: 0 44px 60px;
  .category-group {
    transition: opacity 0.2s;
    &.hidden {
      display: none;
    }
    .category-header {
      display: flex;
      align-items: center;
      gap: 16px;
      margin-bottom: 32px;
      margin-top: 60px;
      .category-name {
        font-size: 11px;
        letter-spacing: 4px;
        text-transform: uppercase;
        color: @ink;
        font-weight: 300;
        white-space: nowrap;
      }

      .category-line {
        flex: 1;
        height: 0.5px;
        background: @bdr;
      }

      .category-count {
        font-family: 'Roboto Mono', monospace;
        font-weight: 300;
        font-size: 10px;
        color: @mute;
        white-space: nowrap;
      }
    }
    .products-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 24px;
      .product-card {
        background: #ffffff;
        border: 1px solid @bdr;
        cursor: pointer;
        transition: transform 0.2s, border-color 0.2s;
        overflow: hidden;
        &:hover {
          transform: translateY(-3px); border-color: #c8c8c6;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .store-grid {
    padding: 32px 24px 0;

    .category-group {
      .category-header {
        gap: 12px;
        margin-bottom: 20px;
        margin-top: 40px;

        .category-name {
          font-size: 9px;
          letter-spacing: 3.5px;
        }

        .category-count {
          font-size: 9px;
        }
      }

      &:first-child {
        .category-header {
          margin-top: 0;
        }
      }

      .products-grid {
        display: block;

        .product-card {
          width: 100%;
          margin-bottom: 16px;

          &:hover {
            transform: none;
          }

          &:active {
            transform: scale(0.99);
          }
        }
      }
    }
  }
}

</style>
